import * as _ from 'lodash';

/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

import { AppUtilityService } from '../../../../core/services/app-utility.service';
import { ConfigService } from '../../../../core/services/config.service';
import { LmsRendererService } from '../../../../core/services/lms-renderer.service';
import { LocoDetail } from '../../../../core/model/loco-detail.model';
import { LocoFeature } from '../../../../loco/shared/model/loco-feature.model';
import { OverlayPanel } from 'primeng/overlaypanel';
import { StaticDataStoreService } from '../../../../core/services/static-datastore.service';
import { StationDetail } from '../../../shared/model/station-detail.model';
import { StationLocoDetail } from '../../../shared/model/station-loco-detail.model';
import { UserService } from '../../../../core/services/user.service';
import { debounceTime } from 'rxjs/operators';

/**
 * @export
 * @class YardLocalContainerDataComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-yard-local-container-data',
  templateUrl: './yard-local-container-data.component.html',
  styleUrls: ['./yard-local-container-data.component.scss']
})

export class YardLocalContainerDataComponent implements AfterViewInit, OnInit, OnChanges {

  @Input() stationDetailArr: Array<StationDetail>;
  @Input() locateLocoId: string;
  @Output() locoOrStationSelectionEvent = new EventEmitter<Array<StationDetail>>();
  @Output() onLocoSelect = new EventEmitter();
  @Output() showStationMenu = new EventEmitter();
  totalRecords: number;
  showingFrom: number;
  showingTo: number;
  scrollHeight: number;
  upperHeight = 189;
  configData: any;
  firstIndex: number;
  lastIndex: number;
  loadDataToShow: Array<StationDetail>;
  rowsPerPage;
  terminalOverlay: OverlayPanel;

  @ViewChild('viewPortPaging') viewPageDirective;

  /**
   * Creates an instance of YardLocalContainerDataComponent.
   * @param {AppUtilityService} appUtilityService
   * @memberof YardLocalContainerDataComponent
   */
  constructor(private appUtilityService: AppUtilityService,
    private staticDataStoreService: StaticDataStoreService,
    private configService: ConfigService,
    private lmsRendererService: LmsRendererService, 
    public user: UserService) {
    this.configData = this.configService.getConfigData();
    this.lmsRendererService.resizeObervable.pipe(debounceTime(10)).subscribe((isResize) => {
      if (isResize) {
        this.calculatePageHeight();
        this.prepareDataList();
        this.processHeightOfTable();
      }
    });
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberof YardLocalContainerDataComponent
   */
  ngOnInit() {
    this.rowsPerPage = this.appUtilityService.getRowPerPageCount(82, this.upperHeight);
    if (this.stationDetailArr) {
      this.totalRecords = this.stationDetailArr.length;
    }
    this.calculatePageHeight();
  }

  private calculatePageHeight() {
    let heightToAdjust = 0;
    if (this.lmsRendererService.getWindowWidth() < 1280) {
      heightToAdjust = 21;
    }
    this.scrollHeight = this.lmsRendererService.getWindowHeight() - this.upperHeight - heightToAdjust;
  }

  /**
   * Invoked when lifecycle hook change.
   * scroll move to top.
   * @memberof YardLocalContainerDataComponent
   */
  ngOnChanges() {
    if (this.stationDetailArr && this.stationDetailArr.length > 0) {
      this.prepareDataList();
    } else {
      this.loadDataToShow = [];
      this.firstIndex = 0;
      this.lastIndex = 0;
      this.totalRecords = 0;
      this.showingFrom = 0;
      this.showingTo = 0;
    }
    const yardLocalDiv = document.getElementById('yardLocalContainer');
    if (yardLocalDiv) {
      yardLocalDiv.scrollTop = 0;
    }
    setTimeout(() => {
      this.processHeightOfTable();
    }, 200);
  }

  /**
   * Prepara data list when scroll is per page scrolled.
   *
   * @private
   * @memberof YardLocalContainerDataComponent
   */
  private prepareDataList() {
    this.rowsPerPage = this.appUtilityService.getRowPerPageCount(82, this.upperHeight);
    this.loadDataToShow = this.stationDetailArr.slice(0, this.rowsPerPage);
    this.firstIndex = this.stationDetailArr.indexOf(this.loadDataToShow[0]);
    this.lastIndex = this.stationDetailArr.indexOf(this.loadDataToShow[this.loadDataToShow.length - 1]);
    this.totalRecords = this.stationDetailArr.length;
    setTimeout(() => {
      this.scrollEventOccured();
    }, 500);

  }

  /**
   * Invoked after the view initialize and process the height calculation of data grid.
   * @memberof YardLocalContainerDataComponent
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.processHeightOfTable();
    }, 200);
  }

  /**
   * Calculate height of data grid and shwo paging accordingly
   * @private
   * @memberof YardLocalContainerDataComponent
   */
  private processHeightOfTable() {
    const yardLocalDiv = document.getElementById('yardLocalContainer');
    if (yardLocalDiv) {
      const clientHeight = yardLocalDiv.clientHeight - 21;
      this.totalRecords = this.stationDetailArr.length;
      const displayedRows = Math.floor(clientHeight / 92);
      this.showingFrom = 1;
      this.showingTo = this.showingFrom + displayedRows;
      if (this.showingTo > this.totalRecords) {
        this.showingTo = this.totalRecords;
      }
    }
  }

  /**
   * Scroll event triggered on data grid.
   * @memberof YardLocalContainerDataComponent
   */
  public scrollEventOccured() {
    if (this.terminalOverlay) {
      this.terminalOverlay.hide();
    }
    const yardLocalDiv = document.getElementById('yardLocalContainer');
    if (yardLocalDiv) {
      const clientHeight = yardLocalDiv.clientHeight - 21;
      const scrollHeight = yardLocalDiv.scrollHeight - 21;
      const scrollTop = yardLocalDiv.scrollTop;
      const diff = (clientHeight + scrollTop) - scrollHeight;
      if (diff <= 2 && diff >= -2) {
        this.loadNextSetofData();
      }
      if (this.viewPageDirective) {
        this.viewPageDirective.updateScreenSizeSetting();
      }
    }
  }

  /**
   * Load next set of data when scroll performed.
   * @private
   * @memberof YardLocalContainerDataComponent
   */
  private loadNextSetofData() {
    this.loadDataToShow = this.stationDetailArr.slice(0, (this.stationDetailArr.length > (this.lastIndex + this.rowsPerPage) ? (this.lastIndex + this.rowsPerPage) : this.stationDetailArr.length));
    this.firstIndex = this.stationDetailArr.indexOf(this.loadDataToShow[0]);
    this.lastIndex = this.stationDetailArr.indexOf(this.loadDataToShow[this.loadDataToShow.length - 1]);
  }

  /**
   * Convert station loco detail object in to loco detail object for context menu.
   * @param {StationLocoDetail} stationLocoDetail
   * @returns {LocoDetail}
   * @memberof YardLocalContainerDataComponent
   */
  convertStationLocoToLocoDetail(stationLocoDetail: StationLocoDetail): LocoDetail {
    let locoDetail = {};
    if (stationLocoDetail) {

      const listOfFeature: Array<LocoFeature> = [];
      for (let i = 0; i < stationLocoDetail.features.length; i++) {
        const locoFeature = {
          featureDescription: stationLocoDetail.features[i]
        };
        listOfFeature.push(locoFeature);
      }

      locoDetail = {
        shadowIndicator: stationLocoDetail.shadowIndicator,
        locomotiveIdentifier: stationLocoDetail.locomotive,
        duration: stationLocoDetail.duration,
        directionFacing: stationLocoDetail.directionFacing,
        shoppedStored: stationLocoDetail.shoppedStored,
        clazz: stationLocoDetail.clazz,
        partialPower: stationLocoDetail.partialPower,
        trailUseOnly: stationLocoDetail.trailUseOnly,
        gpsIdleHours: stationLocoDetail.gpsIdleHrs,
        specificGPSIdle: stationLocoDetail.specificGpsIdl,
        axles: stationLocoDetail.axles,
        permanentTag: stationLocoDetail.permanentTag,
        locoTag: stationLocoDetail.locomotiveTag,
        questionMark: stationLocoDetail.questionMark,
        rduInstalled: stationLocoDetail.telemetry,
        alertLevel: stationLocoDetail.labAlertLevel,
        lowFuelIndicator: stationLocoDetail.lowFuelInd,
        formDue: stationLocoDetail.formDue,
        deadFlag: stationLocoDetail.deadProblem,
        otherFlag: stationLocoDetail.otherProblem,
        ptcIncident: stationLocoDetail.ptcIncident,
        ptcEquipped: stationLocoDetail.ptcEquipped,
        formPastDue: stationLocoDetail.formPastDue,
        miles: stationLocoDetail.milesRemaining,
        lastFueledDate: stationLocoDetail.lastFueledMMDD,
        xFormDue: stationLocoDetail.xFormDue,
        serviceDue: stationLocoDetail.serviceDue,
        horsePower: stationLocoDetail.horsePower,
        tractiveEffort: stationLocoDetail.tractiveEffort,
        capacity: stationLocoDetail.capacity,
        plannedAssignment: stationLocoDetail.planCurrAsgn,
        plannedOrCurrentAssign: stationLocoDetail.planCurrAsgn,
        qDueDate: stationLocoDetail.qDueDate,
        maintenanceType: stationLocoDetail.maintenanceType,
        deadDate: stationLocoDetail.deadDate,
        thpTerminal: stationLocoDetail.thpTerminalI,
        thpType: stationLocoDetail.thpTypeC,
        thpText: stationLocoDetail.thpTypeDescX,
        responsibleRoad: stationLocoDetail.responsibleScacC,
        locoAllocDiv: stationLocoDetail.locoAllocDiv,
        locoAllocStation: stationLocoDetail.locoAllocStat,
        locoAllocType: stationLocoDetail.locoAllocType,
        locoAllocPermFlag: stationLocoDetail.allocPermFlag,
        bestAvailableLocDetail: stationLocoDetail.lastRptInfo,
        terminalArrival: stationLocoDetail.terminalArrv,
        terminalDuration: stationLocoDetail.termDuration,
        previousAssignment: stationLocoDetail.prevAssignment,
        lastReportingSource: stationLocoDetail.lastRptSource,
        lastReportingDateTime: stationLocoDetail.lastRptDateTm,
        lastReportingMilepost: stationLocoDetail.lastRptMp,
        lastReportingCityState: stationLocoDetail.lastRptCitySt,
        tripPlans: this.getTripPlans(stationLocoDetail),
        backupTripPlan: stationLocoDetail.backupTripPlan,
        problemCodes: stationLocoDetail.problemCodes,
        remarks: stationLocoDetail.remarks,
        noteText: stationLocoDetail.noteText,
        listOfFeature: listOfFeature,
        assignedPlannedFlag: stationLocoDetail.assignedPlanned,
        intendedUsageCode: stationLocoDetail.intendUsageC,
        intendedUsageReason: stationLocoDetail.intendUsageRsnC,
        intendedUsgaeNote: stationLocoDetail.intendUsageNteX,
        backgroundColor: stationLocoDetail.backgroundColor,
        noGpsReporting: stationLocoDetail.noGpsReporting,
        textAboveLoco: stationLocoDetail.textAboveLoco,
        textBelowLoco: stationLocoDetail.textBelowLoco,
        notesFlag: stationLocoDetail.notesExist,
        trfIncidentS: stationLocoDetail.trfIncidentS
      };
    }
    return locoDetail;
  }

  /**
   * Invoked for selection of station.
   *
   * @param {StationDetail} stationDetail
   *
   * @memberof YardLocalContainerDataComponent
   */
  setSelectedStation(stationDetail: StationDetail) {
    if (stationDetail && stationDetail.isStationSelected) {
      stationDetail.isStationSelected = false;
    } else {
      stationDetail.isStationSelected = true;
    }
    _.forEach(this.stationDetailArr, function (stDetail, key) {
      if (JSON.stringify(stDetail) !== JSON.stringify(stationDetail)) {
        stDetail.isStationSelected = false;
      }
    });
    this.resetLocatedLoco();
    this.locoOrStationSelectionEvent.emit(this.stationDetailArr);
  }

  /**
   * Invoked when click on locomotive for selection.
   * @param {any} stationLocoDetail
   *
   * @memberof YardLocalContainerDataComponent
   */
  setSelectedLoco(stationLocoDetail: StationLocoDetail) {
    if (stationLocoDetail && stationLocoDetail.shadowIndicator !== 'S') {
      if (stationLocoDetail.isLocoSelected) {
        stationLocoDetail.isLocoSelected = false;
      } else {
        stationLocoDetail.isLocoSelected = true;
      }
      this.resetLocatedLoco();
      this.locoOrStationSelectionEvent.emit(this.stationDetailArr);
    }
  }

  resetLocatedLoco() {
    this.stationDetailArr.forEach((stationDetail) => {
      stationDetail.listOfLocomotives.forEach((stationLocoDetail) => {
        stationLocoDetail.isLocoHighlighted = false;
      });
    });
  }
  /**
  * This method shows lococmotive COntext menu.
  * @param {LocoDetail} loco
  * @memberOf YardLocalContainerDataComponent
  */
  public showLocoContextMenu(stationDetail: StationDetail, stationLocoDetail: StationLocoDetail) {
    if (this.terminalOverlay) {
      this.terminalOverlay.hide();
    }
    if (stationDetail && stationLocoDetail && stationLocoDetail.shadowIndicator.trim().toUpperCase() !== 'S') {
      let loco: LocoDetail = this.convertStationLocoToLocoDetail(stationLocoDetail);
      if (loco) {
        loco = this.appUtilityService.getFeaturesFromPicklist(loco);
        if (loco) {
          const locoId = 'station-' + stationDetail.allocStation + '-loco-' + stationLocoDetail.locomotive;
          this.onLocoSelect.emit({ loco: loco, locoId: locoId });
        }
      }
    }
  }

  /**
   * Show station context menu on right click.
   * @param {StationDetail} stationDetail
   * @param {number} i
   *
   * @memberof YardLocalContainerDataComponent
   */
  showStationContextMenu(stationDetail: StationDetail, i: number) {
    if (this.terminalOverlay) {
      this.terminalOverlay.hide();
    }
    const stationId = 'station-' + stationDetail.allocStation + '-' + i;
    if (stationDetail && stationDetail.allocStation) {
      this.showStationMenu.emit({ stationDetail: stationDetail, stationId: stationId });
    }
  }

  /**
   * Retrieve trip plan values from station loco detail.
   * @param {StationLocoDetail} stationLocoDetail
   * @returns {Array<string>}
   * @memberof YardLocalContainerDataComponent
   */
  getTripPlans(stationLocoDetail: StationLocoDetail): Array<string> {
    const tripPlans: Array<string> = [];
    if (stationLocoDetail) {
      for (let i = 1; i <= 9; i++) {
        if (stationLocoDetail['tripPlan0' + i]) {
          tripPlans.push(stationLocoDetail['tripPlan0' + i]);
        }
      }
      if (stationLocoDetail.tripPlan10) {
        tripPlans.push(stationLocoDetail.tripPlan10);
      }
    }
    return tripPlans;
  }

  /**
   * Show Overlay data when click on station arraow.
   * @param {any} event
   * @param {OverlayPanel} panel
   * @param {StationDetail} stationDetail
   * @memberof YardLocalContainerDataComponent
   */
  showOverlay(event, panel: OverlayPanel, stationDetail: StationDetail) {
    if (stationDetail) {
      const totalLine = stationDetail.totalLine;
      if (totalLine && _.split(totalLine, ':').length >= 2) {
        const totalLineArr = _.split(_.split(totalLine, ':')[1], ',');
        for (let i = 0; i < totalLineArr.length; i++) {
          const a = _.split(totalLineArr[i], '=');
          switch (a[0] && a[0].trim()) {
            case 'Plan':
              stationDetail.plan = a[1] && a[1].trim();
              break;
            case 'Alloc':
              stationDetail.alloc = a[1] && a[1].trim();
              break;
            case 'Shop/Store/OOS(Pink)':
              stationDetail.shopStoreOOS = a[1] && a[1].trim();
              break;
            case 'Out Geo(Grey)':
              stationDetail.outGeo = a[1] && a[1].trim();
              break;
            case 'Net Alloc':
              if (a[1] && a[1].trim()) {
                stationDetail.netAlloc = a[1];
                const netAllocArr = a[1].split('(');
                if (netAllocArr && netAllocArr.length > 0) {
                  stationDetail.netAllocValue = netAllocArr[0];
                } else {
                  stationDetail.netAllocValue = a[1];
                }
              }
              break;
            case 'Other Y/L':
              stationDetail.otherYL = a[1] && a[1].trim();
              break;
            case 'Road':
              stationDetail.road = a[1] && a[1].trim();
              break;
            case 'Avail vs. Plan':
              stationDetail.availVsPlan = a[1] && a[1].trim();
              break;
          }
        }
      }
      this.terminalOverlay = panel;
      panel.show(event);
    }
  }

  getPaginationData($event) {
    this.showingFrom = $event.paging.start;
    this.showingTo = $event.paging.end;
  }

}
